/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function SiteStructure({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g clipPath="url(#SiteStructure_svg__clip0_3143_1807)"><path fill="currentColor" fillRule="evenodd" d="M9.5.398a1.1 1.1 0 0 1 1.1 1.1v3a1.1 1.1 0 0 1-1.1 1.1h-.9V7c0 .22.18.4.4.4h3A1.6 1.6 0 0 1 13.6 9v1.398h.9a1.1 1.1 0 0 1 1.1 1.1v3a1.1 1.1 0 0 1-1.1 1.1h-3a1.1 1.1 0 0 1-1.1-1.1v-3a1.1 1.1 0 0 1 1.1-1.1h.9V9a.4.4 0 0 0-.4-.4H9c-.379 0-.726-.133-1-.353-.274.22-.621.353-1 .353H4a.4.4 0 0 0-.4.4v1.398h.9a1.1 1.1 0 0 1 1.1 1.1v3a1.1 1.1 0 0 1-1.1 1.1h-3a1.1 1.1 0 0 1-1.1-1.1v-3a1.1 1.1 0 0 1 1.1-1.1h.9V9A1.6 1.6 0 0 1 4 7.4h3a.4.4 0 0 0 .4-.4V5.598h-.9a1.1 1.1 0 0 1-1.1-1.1v-3a1.1 1.1 0 0 1 1.1-1.1zm-7.9 14h2.8v-2.8H1.6zm10 0h2.8v-2.8h-2.8zm-5-10h2.8v-2.8H6.6z" clipRule="evenodd" /></g></svg>;
}
;